import {EDIT_NOTE, SHOW_NEW_NOTE} from '../../actions/types';

let defaultState = {
    showNewNote: false,
    noteToEdit: false
};

export default function(state = defaultState, action){
    switch (action.type){
        case SHOW_NEW_NOTE:
            return {showNewNote: action.payload, noteToEdit: false};
        case EDIT_NOTE:
            return {showNewNote: true, noteToEdit: action.payload};
        default:
            break;
    }
    return state;
}


// WEBPACK FOOTER //
// ./src/reducers/Notes/index.js